import './footer.css';
import {
  FaHome,
  FaEnvelope,
  FaPhone,
} from 'react-icons/fa';
import {Link} from 'react-router-dom';

const Footer = () => {
  return (
    <div className="mt-5">
      <footer className="text-center text-lg-start text-white" style={{ backgroundColor: '#1c2331' }}>
        {/* Social media section */}
        <section className="d-flex justify-content-between p-2" style={{ backgroundColor: '#0f37bb' }}>
          <div className="me-5 d-flex align-items-center">
            <span id='footer-heading'>Get connected with us on social networks:</span>
          </div>
          <div
  style={{
    display: 'flex',
    alignItems: 'center',
  }}
>
  <a
  href="https://www.linkedin.com/company/panorama-software-solutions/"
  className="me-4"
  target="_blank"
  rel="noopener noreferrer"
>
  <div className="icon-wrapper">
    <img
      src="/assets/images/footer/linkedin.png"
      alt="LinkedIn"
      className="social-icon"
      id='linkedIn'
    />
  </div>
</a>

<a
  href="https://www.instagram.com/panoramasoftwares/?utm_medium=copy_link"
  className="me-4"
  target="_blank"
  rel="noopener noreferrer"
>
  <div className="icon-wrapper">
    <img
      src="/assets/images/footer/instagram.png"
      alt="Instagram"
      className="social-icon"
      id='instagram'
    />
  </div>
</a>


</div>
        </section>

        {/* Links section */}
        <section>
          <div className="container-fluid text-center text-md-start mt-5" style={{ fontSize: '0.85rem' }}>
            <div className="row mt-1">
              {/* Company Info */}
              <div className="fadee col-md-3 col-lg-4 col-xl-3 mx-auto ">
                <span className="text-uppercase fw-bold">Panorama Software Solutions Pvt ltd</span>
                <p>In panorama software solutions, our goal is innovation, with the aim of leaving a mark worth following and imitating. Our endeavour began in 2018, when the founders of this venture Akshay Garg and Lokesh Singla, had a vision of promoting innovation. Today, we are a team of 60+ highly skilled employees who deliver exceptional work and make dreams come true.</p>
              </div>

              {/* Products */}
              <div className="fadee col-md-2 col-lg-2 col-xl-2">
                <span className="text-uppercase fw-bold">Services</span>
                <p><Link to="/website-development">Web Development</Link></p>
                <p><Link to="/mobile-development" >Mobile Development</Link></p>
                <p><Link to="/quality-assurance" >Quality Assurance</Link></p>
                <p><Link to="/staffing-solutions" >Staffing Solutions</Link></p>
                <p><Link to="/buisness-branding" >Business Branding</Link></p>
                <p><Link to="/graphic-designing" >Graphic Designing</Link></p>
                <p><Link to="/custom-web-solution" >Custom Web Solution</Link></p>
                <p><Link to="/social-media-marketing" >Social Media Marketing</Link></p>

              </div>

              {/* Useful links */}
              <div className="fadee col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <span className="text-uppercase fw-bold mb-4">Quick links</span>
                {/* <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: 60, backgroundColor: '#0f37bb', height: 2 }} /> */}
                <p><Link to="/" >Home</Link></p>
                <p><Link to="/about-us" >About Us</Link></p>
                <p><Link to="/contact-us" >Contact Us</Link></p>
                <p><Link to="/career" >Careers</Link></p>
                <p><Link to="/blog" >Blogs</Link></p>
              </div>

              {/* Contact */}
              <div className="fadee col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <span className="text-uppercase fw-bold">Contact</span>
                {/* <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: 60, backgroundColor: '#0f37bb', height: 2 }} /> */}
                <p><FaHome className="me-2" />621-622, Tower 1, Assotech Business Cresterra, Sector 135, Noida, India</p>
                <p><FaEnvelope className="me-2" />hr@panoramasoftware.in</p>
                <p><FaPhone className="me-2" /> +91-98888-87651</p>
                <p><FaPhone className="me-2" /> +91-95656-45656</p>
              </div>
            </div>
          </div>
        </section>

        {/* Copyright */}
        <div className="fadee text-center p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
          <p>© {new Date().getFullYear()} Panorama Softwares Solutions Pvt Ltd. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
